var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.864 3.843L6.157 3.136L1.5 7.793V8.5H2.207L6.864 3.843ZM7.571 3.136L8.278 2.429L7.571 1.722L6.864 2.429L7.571 3.136ZM2.621 9.5H0.5V7.3785L7.2175 0.660996C7.31126 0.56726 7.43842 0.514603 7.571 0.514603C7.70358 0.514603 7.83074 0.56726 7.9245 0.660996L9.339 2.0755C9.43274 2.16926 9.48539 2.29641 9.48539 2.429C9.48539 2.56158 9.43274 2.68873 9.339 2.7825L2.6215 9.5H2.621Z",
    fill: "#2DC3E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencilIcon.e2c7858fb1e16d553a6d4de9522d1ed8.svg";
export { ForwardRef as ReactComponent };